import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `DELETE /client/:cid/users/:id/hubs/:hub_id`. */
export const revokeHubAccess = async (user_id: string, hub_id: string): Promise<any> => {
  await lpRequest('DELETE', clientPath(`/users/${user_id}/hubs/${hub_id}`));

  return getUser(user_id);
};
